<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import Uppy from "@uppy/core";
// import XHRUpload from "@uppy/xhr-upload";
import { AwsS3Multipart, uploadedKey } from "@/utils/uppyS3Multipart";

import Dashboard from "@uppy/dashboard";
// import Form from "@uppy/form";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
import { s3PublicUrl } from "@/utils/s3PublicUrl";

import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    width: {
      required: true,
    },
    height: {
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
      isLoading: false,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.destroy();
  },
  methods: {
    instantiateUppy() {
      let self = this;
      this.uppy = new Uppy({
        debug: false,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        autoProceed: true,
        allowMultipleUploadBatches: false,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 1,
          allowedFileTypes: [
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ],
          // allowedFileTypes: ['image/*', 'application/doc', 'application/docx', 'application/pdf']
        },
      })
        .use(Dashboard, {
          hideUploadButton: true,
          theme: this.theme,
          inline: true,
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          browserBackButtonClose: true,
          proudlyDisplayPoweredByUppy: false,
        })
        .use(AwsS3Multipart, {
          limit: 1,
          companionEndpoint: `${this.$store.getters.getApiUrl}`, // FT-018
        });

      this.uppy.on("complete", (event) => {
        if (event.successful[0] !== undefined) {
          // this.payload = event.successful[0].response.body.path;
          // const imageName = uuid.v1();
          // let fileExtention = file.name.split(".")[1];
          console.log(uploadedKey(event.successful[0]));
          this.disabled = false;
          this.axios
            .post(
              `/api/v1/cars_entity_doc_templates/${this.$route.params.id}`,
              {
                cars_entity_doc_templates: {
                  name: uploadedKey(event.successful[0]),
                  url: s3PublicUrl(uploadedKey(event.successful[0])),
                },
              },
              {
                headers: {
                  Authorization: self.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              console.log(response);
              // this.$store.commit(
              //   "setProlongTemplateUrl",
              //   `https://rentprog.storage.yandexcloud.net/${event.successful[0].s3Multipart.key}`
              // );
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
            });
        }
      });

      const uploadedFileData = (file, response) => {
        return JSON.stringify(response.body);
      };
    },
    updatePreviewPath({ path }) {
      this.previewPath = path;

      return this;
    },
    resetUploader() {
      this.uppy.cancelAll();
      this.disabled = true;

      return this;
    },
    confirmUpload() {
      if (this.payload) {
        this.disabled = true;
        this.axios
          .post("/store", { file: this.payload })
          .then(({ data }) => {
            this.updatePreviewPath(data).resetUploader();
            this.$notify("Файлы загружены!", "Вы успешно загрузили файлы!", "success", 5000);
          })
          .catch((err) => {
            console.error(err);

            this.resetUploader();
          });
      } else {
        this.$notify("Ошибка при загрузке!", this.error, "error", 5000);
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
